import TransformandoDados from '../../components/TransformandoDados'
import BannerProjects from '../../components/bannerProjects'
import Rodape from '../../components/rodape'
import SquadBeneficios from '../../components/squadBeneficios'

export default function Data() {
  return (
    <>
      <BannerProjects
        backgroundImage="../assets/cover-data.png"
        bgMobile="../assets/banner-data-mobile.png"
        title="/DATA"
        iconSrc="../assets/icone-projectiva-nex2ai.png"
        iconAlt="Projectiva Nex2AI"
        iconText="nex"
        iconTextBold="2ai"
        descriptionBold=""
        description={
          <>
            Desenvolvemos{' '}
            <strong className="font-inter-bold">soluções preditivas</strong> que
            facilitam a tomada de{' '}
            <strong className="font-inter-bold">
              decisões rápidas e assertivas
            </strong>{' '}
            através da organização, visualização e análise de dados de negócios.
          </>
        }
        footerText="VERTICAL INNOVATION | Intelligence "
        buttonText="Quero me conectar"
        buttonColor="from-[#FC0021] via-[#FC0021] to-[#5534D9]"
        brand="nex2ai"
      />
      <TransformandoDados />
      <SquadBeneficios
        title={
          <p className="text-[2rem] text-center md:text-left md:text-5xl font-inter-light">
            As 5 abordagens para{' '}
            <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] bg-clip-text text-transparent relative">
              {' '}
              análise de dados
            </span>
          </p>
        }
        cards={[
          {
            icon: '../assets/icones/analise-descritiva.svg',
            title: 'Análise descritiva',
            text: 'Oferecemos uma visão abrangente através de um painel de período, utilizando métricas como médias, medianas e gráficos para uma análise clara e detalhada dos dados.',
            glowColor: '#FC00218C',
          },
          {
            icon: '../assets/icones/sheet.png',
            title: 'Análise diagnóstica',
            text: 'Analisamos padrões e relações entre variáveis, para identificar ocorrências de forma preditiva.',
            glowColor: '#FC00218C',
          },
          {
            icon: '../assets/icones/analise-preditiva.svg',
            title: 'Análise preditiva',
            text: 'Prevemos resultados futuros baseados em dados históricos usando técnicas de modelagem estatística e aprendizado de máquina.',
            glowColor: '#FC00218C',
          },
          {
            icon: '../assets/icones/analise-prescritiva.svg',
            title: 'Análise Prescritiva',
            text: 'Sugerimos ações específicas a serem tomadas com base nas análises anteriores para alcançar os melhores resultados possíveis.',
            glowColor: '#FC00218C',
          },
          {
            icon: '../assets/icones/analise-temporeal.svg',
            title: 'Análise em tempo real',
            text: 'Tomadas de decisão em tempo real são facilitadas pela nossa análise de dados imediata durante a sua geração.',
            glowColor: '#FC00218C',
          },
        ]}
      />
      <Rodape />
    </>
  )
}
